
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { int32ToString, equals, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { BlockHeader, TextValue } from "../Components/Text.js";
import { TextButton } from "../Components/Button.js";
import { empty as empty_1, toArray, isEmpty, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { AppVariant, Variant as Variant_1 } from "../Variant.js";
import { usePermissions } from "../UserPermissions.js";
import { OpenFullDataExportDialog } from "./Dialogs/FullDataExportDialog.js";
import { Msg } from "./Types.js";
import { Feature, isFeatureEnabled } from "../FeatureFlip.js";
import { Permission, Permissions_has } from "../Shared/Roles.js";
import { ImportDeleteDialog } from "./Dialogs/DeleteImport.js";
import { Table } from "../Widgets/Table/Table.js";
import { ColumnDefinition$1, CellContent } from "../Widgets/Table/Types.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../Components/Skeleton.js";

export function SelectListItem(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-4", "w-[25rem]", "rounded"])], (elems_1 = [reactElement("div", createObj(ofArray([["data-test-id", props.TestId], ["className", join(" ", ["flex", "justify-between"])], (elems = toList(delay(() => append(singleton(createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: t(props.BtnTitleTranslationKey),
    })), delay(() => (props.IsDisabled ? singleton(createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: t("importer.not_active"),
    })) : singleton(createElement(TextButton, {
        ComponentState: "enabled",
        Label: props.BtnText,
        OnClick: props.Callback,
        TestId: concat(props.TestId, ..."-open-button"),
        Variant: "blueButton",
    }))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export const consumableText = "importer.consumable_description";

export const userText = "importer.user_import_description";

export const roomsText = "importer.rooms_import_description";

export const labelsText = "importer.labels_import_description";

export const employeesText = "importer.employees_import_description";

export const projectsText = "importer.projects_import_description";

export const constructionSiteText = "importer.constructionsites_import_description";

export const externalPersonText = "importer.externalprojects_import_description";

export const studentsText = "importer.students_import_description";

export const schoolClassesText = "importer.schoolclasses_import_description";

export const vehiclesText = "importer.vehicles_import_description";

export const subcontractorText = "importer.subcontractor_import_description";

export const exportSpecificToolText = "importer.export_specific_tool_description";

export const exportSimpleToolText = "importer.export_toolwithquantity_description";

export const exportConsumableText = "importer.export_consumables_description";

export const documentText = "importer.document_import_description";

function SelectImportToolType(props) {
    let elems;
    const patternInput = useTranslation();
    const matchValue = props.State.CustomerConfiguration;
    if (matchValue == null) {
        return defaultOf();
    }
    else {
        const config = matchValue;
        const btnText = patternInput[0]("general.open");
        return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems = toList(delay(() => append(singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "importer.specific_tool",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "tool"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-tools",
            TranslationKey: "importer.specific_tool_description",
        })), delay(() => append(singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "importer.simple_tool",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "toolwithquantity"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-tools-with-quantity",
            TranslationKey: "importer.simple_tool_description",
        })), delay(() => append(singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "general.consumable",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "consumable"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-consumables",
            TranslationKey: consumableText,
        })), delay(() => append(isEmpty(props.CurrentUser.BusinessUnitIds) ? singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "general.category",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "label"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-categories",
            TranslationKey: labelsText,
        })) : empty(), delay(() => append(config.ReceiverVisibilityConfiguration.Users ? singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "receivers.user",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "user"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-users",
            TranslationKey: userText,
        })) : empty(), delay(() => append(config.ReceiverVisibilityConfiguration.Employees ? singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "receivers.employee",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "employee"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-employees",
            TranslationKey: employeesText,
        })) : empty(), delay(() => append(config.ReceiverVisibilityConfiguration.Projects ? singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "receivers.project",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "project"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-projects",
            TranslationKey: projectsText,
        })) : empty(), delay(() => append(config.ReceiverVisibilityConfiguration.Rooms ? singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "receivers.room",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "room"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-rooms",
            TranslationKey: roomsText,
        })) : empty(), delay(() => append(config.ReceiverVisibilityConfiguration.Subcontractos ? singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "receivers.subcontractor",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "subcontractor"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-subcontractors",
            TranslationKey: subcontractorText,
        })) : empty(), delay(() => append(config.ReceiverVisibilityConfiguration.ConstructionSites ? singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "receivers.constructionsite",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "constructionsites"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-construction-sites",
            TranslationKey: constructionSiteText,
        })) : empty(), delay(() => append(config.ReceiverVisibilityConfiguration.ExternalPersons ? singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "receivers.externalperson",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "externalperson"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-external-persons",
            TranslationKey: externalPersonText,
        })) : empty(), delay(() => append((config.ReceiverVisibilityConfiguration.Students && equals(Variant_1, new AppVariant(1, []))) ? singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "receivers.student",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "student"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-students",
            TranslationKey: studentsText,
        })) : empty(), delay(() => append((config.ReceiverVisibilityConfiguration.SchoolClasses && equals(Variant_1, new AppVariant(1, []))) ? singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "receivers.school_class",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "schoolclasses"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-school-classes",
            TranslationKey: schoolClassesText,
        })) : empty(), delay(() => append(config.ReceiverVisibilityConfiguration.Vehicles ? singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "receivers.vehicles",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "vehicles"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-vehicles",
            TranslationKey: vehiclesText,
        })) : empty(), delay(() => append(singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "tool.last_check",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "lastinspectiondates"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-last-check",
            TranslationKey: vehiclesText,
        })), delay(() => append(singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "importer.inspection_result_import.title",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "inspectionresults"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-inspection-results",
            TranslationKey: "importer.inspection_result_import.description",
        })), delay(() => singleton(createElement(SelectListItem, {
            BtnText: btnText,
            BtnTitleTranslationKey: "importer.documents.header",
            Callback: () => {
                RouterModule_nav(ofArray(["importer", "document"]), 1, 1);
            },
            IsDisabled: props.FormState === "disabled",
            TestId: "importer-document",
            TranslationKey: documentText,
        })))))))))))))))))))))))))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

function SelectExportToolType(props) {
    let elems;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const btnText = t("general.download_table");
    const patternInput_1 = reactApi.useState(false);
    const setIsFullDataBackupDialogOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems = toList(delay(() => append(singleton(createElement(OpenFullDataExportDialog, {
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsFullDataBackupDialogOpen(false);
        },
        SuccessCallback: () => {
            setIsFullDataBackupDialogOpen(false);
        },
    })), delay(() => append(singleton(createElement(SelectListItem, {
        BtnText: btnText,
        BtnTitleTranslationKey: "importer.specific_tool",
        Callback: () => {
            props.Dispatch(new Msg(3, []));
        },
        IsDisabled: props.FormState === "disabled",
        TestId: "exporter-tools",
        TranslationKey: exportSpecificToolText,
    })), delay(() => append(singleton(createElement(SelectListItem, {
        BtnText: btnText,
        BtnTitleTranslationKey: "importer.simple_tool",
        Callback: () => {
            props.Dispatch(new Msg(4, []));
        },
        IsDisabled: props.FormState === "disabled",
        TestId: "exporter-tools-with-quantity",
        TranslationKey: exportSimpleToolText,
    })), delay(() => append(singleton(createElement(SelectListItem, {
        BtnText: btnText,
        BtnTitleTranslationKey: "general.consumable",
        Callback: () => {
            props.Dispatch(new Msg(5, []));
        },
        IsDisabled: props.FormState === "disabled",
        TestId: "exporter-consumables",
        TranslationKey: exportConsumableText,
    })), delay(() => append(props.AccountSettings.SetsEnabled ? singleton(createElement(SelectListItem, {
        BtnText: btnText,
        BtnTitleTranslationKey: "general.set",
        Callback: () => {
            props.Dispatch(new Msg(6, []));
        },
        IsDisabled: props.FormState === "disabled",
        TestId: "exporter-sets",
        TranslationKey: "general.set",
    })) : empty(), delay(() => {
        let IsDisabled_4;
        return isFeatureEnabled(new Feature(14, [])) ? ((Permissions_has(permissions, new Permission(115, [])) && isEmpty(props.CurrentUser.BusinessUnitIds)) ? singleton(createElement(SelectListItem, (IsDisabled_4 = (props.FormState === "disabled"), {
            BtnText: t("importer.full_data_export_dialog.request"),
            BtnTitleTranslationKey: "importer.full_data_export_dialog.title",
            Callback: () => {
                setIsFullDataBackupDialogOpen(true);
            },
            IsDisabled: IsDisabled_4,
            TestId: "exporter-full",
            TranslationKey: exportConsumableText,
        }))) : empty()) : empty();
    })))))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function SelectUpdateToolType(props) {
    let elems;
    const btnText = useTranslation()[0]("general.open");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems = toList(delay(() => append(singleton(createElement(SelectListItem, {
        BtnText: btnText,
        BtnTitleTranslationKey: "importer.specific_tool",
        Callback: () => {
            RouterModule_nav(ofArray(["updater", "tools"]), 1, 1);
        },
        IsDisabled: props.FormState === "disabled",
        TestId: "updater-tools",
        TranslationKey: "",
    })), delay(() => append(singleton(createElement(SelectListItem, {
        BtnText: btnText,
        BtnTitleTranslationKey: "importer.tool_with_quantity",
        Callback: () => {
            RouterModule_nav(ofArray(["updater", "toolswithquantity"]), 1, 1);
        },
        IsDisabled: props.FormState === "disabled",
        TestId: "updater-toolswithquantity",
        TranslationKey: "",
    })), delay(() => append(singleton(createElement(SelectListItem, {
        BtnText: btnText,
        BtnTitleTranslationKey: "importer.consumable",
        Callback: () => {
            RouterModule_nav(ofArray(["updater", "consumables"]), 1, 1);
        },
        IsDisabled: props.FormState === "disabled",
        TestId: "updater-consumable",
        TranslationKey: "",
    })), delay(() => append(props.AccountSettings.SetsEnabled ? singleton(createElement(SelectListItem, {
        BtnText: btnText,
        BtnTitleTranslationKey: "general.set",
        Callback: () => {
            RouterModule_nav(ofArray(["updater", "sets"]), 1, 1);
        },
        IsDisabled: props.FormState === "disabled",
        TestId: "updater-sets",
        TranslationKey: "",
    })) : empty(), delay(() => append(singleton(createElement(SelectListItem, {
        BtnText: btnText,
        BtnTitleTranslationKey: "updater.consumable_stock.nav_title",
        Callback: () => {
            RouterModule_nav(ofArray(["updater", "consumable-stock"]), 1, 1);
        },
        IsDisabled: props.FormState === "disabled",
        TestId: "updater-consumable-stock",
        TranslationKey: "",
    })), delay(() => singleton(createElement(SelectListItem, {
        BtnText: btnText,
        BtnTitleTranslationKey: "updater.tool_with_quantity_stock.nav_title",
        Callback: () => {
            RouterModule_nav(ofArray(["updater", "tool-with-quantity-stock"]), 1, 1);
        },
        IsDisabled: props.FormState === "disabled",
        TestId: "updater-tool-with-quantity-stock",
        TranslationKey: "",
    })))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function ImportHistory(props) {
    let elems;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setIsDeleteDialogOpen = patternInput_1[1];
    const isDeleteDialogOpen = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = toList(delay(() => {
        let matchValue;
        return append((matchValue = isDeleteDialogOpen, (matchValue == null) ? (empty()) : singleton(createElement(ImportDeleteDialog, {
            ImportId: matchValue,
            IsOpen: isDeleteDialogOpen != null,
            OnClose: () => {
                setIsDeleteDialogOpen(undefined);
            },
            SuccessCallback: () => {
                props.Dispatch(new Msg(0, []));
            },
        }))), delay(() => {
            let TableRows;
            return singleton(createElement(Table, (TableRows = toArray(props.History), {
                ColumnDefinitions: [new ColumnDefinition$1("date", "", t("general.date"), (dto) => (new CellContent(8, [dto.Timestamp])), "dateRange", "date"), new ColumnDefinition$1("importedElements", "", t("general.quantity_3"), (dto_1) => (new CellContent(0, [int32ToString(dto_1.ImportedElements)])), "none", "text"), new ColumnDefinition$1("importType", "", t("importer.type"), (dto_2) => (new CellContent(0, [t(dto_2.ImportType)])), "select", "text"), new ColumnDefinition$1("commission", "", t("importer.is_deleted"), (dto_3) => (dto_3.IsDeleted ? (new CellContent(0, [t("general.yes")])) : (new CellContent(0, [t("general.no")]))), "select", "text"), new ColumnDefinition$1("delete", "", t("general.delete"), (dto_4) => (dto_4.IsDeleted ? (new CellContent(0, [""])) : (((dto_4.ImportType === "importer.tool") ? true : (dto_4.ImportType === "importer.consumable")) ? (new CellContent(2, [createElement(TextButton, {
                    ComponentState: "enabled",
                    Label: t("general.delete"),
                    OnClick: () => {
                        setIsDeleteDialogOpen(dto_4.Id);
                    },
                    TestId: "importer-select-open-button",
                    Variant: "blueButton",
                })])) : (new CellContent(0, [""])))), "select", "text")],
                Controls: empty_1(),
                Options: {
                    BorderStyle: "full",
                    CSVDownload: false,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["date", "asc"],
                    Fullscreen: false,
                    GlobalSearch: false,
                    RowSelection: "disabled",
                    SaveTableConfiguration: false,
                },
                TableKey: "not-defined-table",
                TableRows: TableRows,
            })));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function View(props) {
    let elems_5;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.TokenData, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const formState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_5 = toList(delay(() => {
        let elems_3, elems, elems_2, elems_1;
        const matchValue = state_1.ImportHistory;
        return (matchValue.tag === 0) ? singleton(createElement(Skeleton, {
            Variant: "table",
        })) : append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
            Text: "Importer",
        }), createElement(SelectImportToolType, {
            CurrentUser: props.CurrentUser,
            FormState: formState,
            State: state_1,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_2 = [createElement(BlockHeader, {
            Text: "Exporter",
        }), createElement(SelectExportToolType, {
            AccountSettings: props.AccountSettings,
            CurrentUser: props.CurrentUser,
            Dispatch: dispatch,
            FormState: formState,
            State: state_1,
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-5"])], (elems_1 = [createElement(BlockHeader, {
            Text: "Updater",
        }), createElement(SelectUpdateToolType, {
            AccountSettings: props.AccountSettings,
            CurrentUser: props.CurrentUser,
            Dispatch: dispatch,
            FormState: formState,
            State: state_1,
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
            let elems_4;
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_4 = [createElement(BlockHeader, {
                Text: patternInput_1[0]("importer.history_header"),
            }), createElement(ImportHistory, {
                Dispatch: dispatch,
                FormState: formState,
                History: matchValue.fields[0],
            })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

